<template>
  <section>
    <VerReporte />
    <VerReporteProgramacion />
    <v-card>
      <v-card-text>
        <!-- Cabecera del formulario -->

        <v-card-title class="headline">
          <v-flex xs9>
            <v-icon>bussines</v-icon>
            Reporte de vacación
          </v-flex>
          <v-spacer></v-spacer>
        </v-card-title>
        <!-- Cuerpo del formulario -->
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout>
                <v-flex xs6>
                  <v-text-field
                    type="date"
                    v-model="form.fecha_inicio"
                    label="Fecha inicio"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    :rules="$validate(['required'])"
                    required
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    type="date"
                    v-model="form.fecha_fin"
                    label="Fecha fin"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    :rules="$validate(['required'])"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md9>
                  <v-autocomplete
                    :items="unidades_generales"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_general"
                    @input="obtenerListaFuncionarios()"
                    label="Unidad general"
                    maxlength="50"
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md9>
                  <v-autocomplete
                    :items="unidades_especificas"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_especifica"
                    @input="obtenerListaFuncionarios()"
                    label="Unidad especifica"
                    maxlength="50"
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md4>
                  <v-text-field
                    v-model="form.paterno"
                    label="Paterno"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                  />
                </v-flex>
                <v-flex md4>
                  <v-text-field
                    v-model="form.materno"
                    label="Materno"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                  />
                </v-flex>
                <v-flex md4>
                  <v-text-field
                    v-model="form.nombres"
                    label="Nombres"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md4>
                  <v-text-field
                    v-model="form.ci"
                    label="Cédula de identidad"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                  />
                </v-flex>
                <v-flex md4>
                  <v-text-field
                    v-model="form.item"
                    label="Item"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                  />
                </v-flex>
              </v-layout>
              <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(31,14,180,0.3)"
                @click="
                  obtenerListaFuncionarios(form.fecha_inicio, form.fecha_fin)
                "
                type="submit"
              >
                <v-icon>search</v-icon>
                Buscar
              </v-btn>
              <v-btn
                color="rgba(158,11,127,0.6)"
                @click="limpiarCampos()"
                type="submit"
              >
                <v-icon>redo</v-icon>
                Limpiar
              </v-btn>
              <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(50,150,40,0.7)"
                title="Ver reporte "
                type="submit"
                @click.prevent="verReporte(form, 6)"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
               <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(50,150,40,0.7)"
                title="Ver reporte de Saldos "
                type="submit"
                @click.prevent="verReporteSaldos(form, 15)"
              >
                <v-icon>picture_as_pdf</v-icon>
                REPORTE DE SALDOS
              </v-btn>
            </v-container>
          </v-card-text>
        </v-form>
        <v-data-table
          :headers="headers"
          :items="lista_funcionarios"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ props.item.uni }}
            </td>
            <td class="text-xs-center">
              {{ $moment(props.item.fecha_incor).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ props.item.nom }} {{ props.item.pat }} {{ props.item.mat }}
            </td>
            <td class="text-xs-center">
              {{ props.item.item }}
            </td>
            <td class="text-xs-center">
              {{ props.item.nro_doc }}
            </td>
            <td class="text-xs-center">
              {{ props.item.cargo }}
            </td>

            <td class="text-xs-center">
              {{ props.item.saldo }}
            </td>
            <td class="text-xs-center">
              <v-btn
                color="#f1b3f6"
                @click="verReporte(props.item, 10)"
                icon
                title="Ver reporte de vacaciones"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
              <v-btn
                color="rgb(73,26,230)"
                @click="verReporteProgramacion(props.item)"
                icon
                dark
                title="Ver reporte de cronograma de vacaciones"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<!-- <div v-for="item in items" :key="item.id">
          Datos persona: {{ item.nombre }}
          <br />
          ============Programacion=================
          <div
            v-for="programacion in item.programaciones"
            :key="programacion.id"
          >
            <br />
            Fecha desde: {{ programacion.fecha_desde }}
            <br />
            Fecha hasta: {{ programacion.fecha_hasta }}
            <br />
            ======= REPROGRAMACION =====
            <div
              v-for="reprogramacion in programacion.reprogramaciones"
              :key="reprogramacion.id"
            >
              -------Fecha desde: {{ reprogramacion.fecha_desde }}

              -------Fecha hasta: {{ reprogramacion.fecha_hasta }}
            </div>
          </div>
          =======================00total Dias: 12
        </div> -->

<script>
//import VerReporte from "./dialogs/VerReporte";
import validate from "@/common/mixins/validate";
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import VerReporte from "./dialogs/VerReporte";
import VerReporteReprogramacion from "../asistencia/dialogs/VerReporte.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  mixins: [validate, crud],
  data() {
    return {
      form: {},
      valid: false,
      validated: 0,
      bandera_boton_buscar: true,
      headers: [
        {
          text: "Unidad",
          value: "uni",
          align: "center",
        },
        {
          text: "Fecha de incorporación",
          value: "fecha_incor",
          align: "center",
        },
        {
          text: "Nombre",
          value: "",
          align: "center",
        },
        {
          text: "Item",
          value: "item",
          align: "center",
        },
        {
          text: "CI",
          value: "nro_doc",
          align: "center",
        },
        {
          text: "Cargo",
          value: "cargo",
          align: "center",
        },
        // {
        //   text: "Casos",
        //   value: "prog",
        //   align: "center"
        // },
        {
          text: "Saldo fecha",
          value: "saldo",
          align: "center",
        },
      ],

      unidades_generales: [],
      unidades_especificas: [],
      lista_funcionarios: [],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarListaUnidadesGenerales();
    await this.cargarListaUnidadesEspecificas();
    var date = new Date();
    let primer_dia_mes = new Date(date.getFullYear(), date.getMonth(), 1);
    primer_dia_mes = this.$moment(primer_dia_mes).format("YYYY-MM-DD");
    let ultimo_dia_año = new Date().getFullYear() + "-12-31";
    this.form.id_unidad_general = 0;
    this.form.id_unidad_especifica = 0;
    this.form.materno = "";
    this.form.paterno = "";
    this.form.nombres = "";
    this.form.ci = "";
    this.form.item = "";
    //asignar primer y ultimo dia del año
    let año = new Date().getFullYear() + "";
    let primer_dia = año + "-01-01";
    let ultimo_dia = año + "-12-31";
    this.fecha_desde = primer_dia;
    this.fecha_hasta = ultimo_dia;

    /////
    this.form.fecha_inicio = primer_dia;
    this.form.fecha_fin = ultimo_dia;
    this.bandera_boton_buscar = true;

    await this.obtenerListaFuncionarios(primer_dia, ultimo_dia);
  },
  // Métodos y funciones del componente
  methods: {
    async obtenerListaFuncionarios(fecha_desde, fecha_hasta) {
      try {
        this.bandera_boton_buscar = true;
        if (this.form.fecha_inicio && this.form.fecha_fin) {
          this.lista_funcionarios = [];
          if (this.form.materno) {
            this.form.materno = this.form.materno.toUpperCase();
          }
          if (this.form.nombres) {
            this.form.nombres = this.form.nombres.toUpperCase();
          }
          if (this.form.paterno) {
            this.form.paterno = this.form.paterno.toUpperCase();
          }
          if (!this.form.id_unidad_general) {
            this.form.id_unidad_general = 0;
          }
          if (!this.form.id_unidad_especifica) {
            this.form.id_unidad_especifica = 0;
          }
          if (!this.form.materno) {
            this.form.materno = "";
          }
          if (!this.form.paterno) {
            this.form.paterno = "";
          }
          if (!this.form.nombres) {
            this.form.nombres = "";
          }
          if (!this.form.ci) {
            this.form.ci = "";
          }
          if (!this.form.item) {
            this.form.item = "";
          }

          let res = await this.$service.graphql({
            query: `
                   query{
      runQuery(consulta:"SELECT * FROM vacaciones.fn_rep_cronograma_vacaciones_totales('2023-06-01','2023-06-29',${parseInt(
        this.form.id_unidad_general
      )},'${this.form.paterno}','${this.form.materno}','${
              this.form.nombres
            }','${this.form.ci}','${this.form.item}',${parseInt(
              this.form.id_unidad_especifica
            )}) AS (id_persona integer,id_unidad integer,id_padre integer,uni varchar,pat varchar,mat varchar,nom varchar,nro_doc varchar,item varchar,prog TEXT,dias TEXT,saldo text,fecha_incor DATE,cargo VARCHAR)"){
                    respuesta
                  }
                  }
                `,
          });

          if (res.runQuery.respuesta.length != 0) {
            this.lista_funcionarios = res.runQuery.respuesta;
          }
        } else {
          this.bandera_boton_buscar = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    limpiarCampos() {
      try {
        this.form = {};
        this.bandera_boton_buscar = false;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarListaUnidadesGenerales() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                vUnidadesGeneraless(lista_niveles:"0,1"){
                  rows{
                    id_unidad
                    nombre_unidad
                    nivel
                  }
                }
              }
          `,
        });
        this.unidades_generales = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    verReporteProgramacion(item) {
      try {
        let url;
        let nombre_reporte = "";
        let formato_doc = "output=pdf";
        let nombre_carpeta = "vacaciones";
        let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
          /{carpeta}/g,
          nombre_carpeta
        );
        nombre_reporte = "rpt_cronograma_vacacion";
        url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
        let url_parametros = `${url}&p_fecha_ini=${this.form.fecha_inicio}&p_fecha_fin=${this.form.fecha_fin}&p_unidad_general=0&p_paterno=&p_materno=&p_nombres=&p_ci=${item.nro_doc}&p_item=&p_unidad_especifica=0`;
        console.log("+++++++++++++++++++", url_parametros);
        window.open(url_parametros);
       // this.$bus.$emit("openDialogVerReporte", url_parametros);
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item, valor) {
      if (!item.id_unidad_general) {
        item.id_unidad_general = 0;
      }
      if (!item.id_unidad_especifica) {
        item.id_unidad_especifica = 0;
      }
      if (!item.materno) {
        item.materno = "";
      }
      if (!item.paterno) {
        item.paterno = "";
      }
      if (!item.nombres) {
        item.nombres = "";
      }
      if (!item.ci) {
        item.ci = "";
      }
      if (!item.item) {
        item.item = "";
      }
      item.reprogramacion = valor;
      console.log("****", item.id_unidad_general, item.id_unidad_especifica);
      this.$bus.$emit("openDialogVerReporte", item);
    },
    verReporteSaldos(item, valor) {

      item.reprogramacion = valor;
      console.log("form saldos", item);
      this.$bus.$emit("openDialogVerReporte", item);
    },


    async cargarListaUnidadesEspecificas() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                vUnidadesGeneraless{
                  rows{
                    id_unidad
                    nombre_unidad
                    nivel
                  }
                }
              }
          `,
        });
        this.unidades_especificas = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    save() {
      try {
      } catch (error) {}
    },
  },
  // Definición de componentes importados
  components: {
    VerReporte,
    VerReporteReprogramacion,
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/CronogramaVacaciones2.vue